import React from 'react';
import {
    Routes,
    Route,
} from 'react-router-dom';

import PrivateRoute from './auth/PrivateRoute';
import RequireSpecificCompany from './auth/RequireSpecificCompany';

import MainLayout from './layouts/MainLayout';

import DashboardPage from './pages/dashboard/DashboardPage';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Unauthorized from './pages/Unauthorized';

import ShopsList from './pages/shops/ShopsList';
import ShopForm from './pages/shops/ShopForm';

import DropOffsList from './pages/shops/DropOffsList';
import DropOffForm from './pages/shops/DropOffForm';

import BookingsList from './pages/bookings/BookingsList';
import BookingForm from './pages/bookings/BookingForm';

import RequestsList from './pages/requests/RequestsList';
import RequestForm from './pages/requests/RequestForm';

import ReviewsList from './pages/reviews/ReviewsList';
import ReviewForm from './pages/reviews/ReviewForm';

import AccountingsList from './pages/accountings/AccountingsList';

import Models from './pages/models/Models';
import ModelForm from './pages/models/ModelForm';

import MotorcyclesPage from './pages/motorcycles/MotorcyclesPage';
import MotorcycleFormPage from './pages/motorcycles/MotorcycleFormPage';

import DiscountsList from './pages/discount/DiscountsList';
import DiscountFormPage from './pages/discount/DiscountFormPage';

import PromoCodesPage from './pages/codes/promo/PromoCodesPage';
import PromoCodeFormPage from './pages/codes/promo/PromoCodeFormPage';

import CreditCodesPage from './pages/codes/credits/CreditCodesPage';
import CreditCodeFormPage from './pages/codes/credits/CreditCodeFormPage';

import SalesReport from './pages/reports/SalesReport';
import InsuranceReport from './pages/reports/InsuranceReport';
import LicenseReport from './pages/reports/LicenseReport';

import CompaniesList from './pages/companies/CompaniesList';
import CompanyForm from './pages/companies/CompanyForm';

import UnverifiedCompaniesList from './pages/companies/UnverifiedCompaniesList';
import UnverifiedCompanyForm from './pages/companies/UnverifiedCompanyForm';

import ContactUs from './pages/support/ContactUs';

import SupplierDecisionRoute from './pages/bookings/components/supplier/SupplierDecisionPage';

import NotFound from './pages/NotFound';

function AppRoutes() {
    return (
        <Routes>
            {/* Public routes */}
            <Route
                path="/login"
                element={<Login />}
            />

            <Route
                path="/set-password"
                element={<Login />}
            />

            {/* Protected application */}
            <Route
                path="/"
                element={
                    <PrivateRoute>
                        <MainLayout />
                    </PrivateRoute>
                }
            >
                {/* General */}
                <Route
                    path="dashboard"
                    element={<DashboardPage />}
                />

                <Route
                    path="unauthorized"
                    element={<Unauthorized />}
                />

                <Route
                    path="settings"
                    element={<Settings />}
                />

                {/* Companies */}

                <Route
                    path="companies/list"
                    element={
                        <PrivateRoute requiredRole="ADMIN">
                            <CompaniesList />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="company/new"
                    element={
                        <PrivateRoute requiredRole="ADMIN">
                            <CompanyForm />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="company/edit/:id"
                    element={
                        <CompanyForm />
                    }
                />

                {/* Shops */}
                <Route
                    path="shops/list"
                    element={<ShopsList />}
                />

                <Route
                    path="shops/new"
                    element={
                        <RequireSpecificCompany action="create a shop">
                            <ShopForm />
                        </RequireSpecificCompany>
                    }
                />

                <Route
                    path="shops/edit/:id"
                    element={<ShopForm />}
                />

                {/* Dropoffs */}
                <Route
                    path="dropoffs"
                    element={<DropOffsList />}
                />

                <Route
                    path="dropoff/new"
                    element={
                        <RequireSpecificCompany action="create a drop-off configuration">
                            <DropOffForm />
                        </RequireSpecificCompany>
                    }
                />

                <Route
                    path="dropoff/edit/:id"
                    element={<DropOffForm />}
                />

                {/* Motorcycles */}
                <Route path="motorcycles">
                    <Route
                        index
                        element={<MotorcyclesPage />}
                    />

                    <Route
                        path="new"
                        element={
                            <RequireSpecificCompany action="create a motorcycle">
                                <MotorcycleFormPage />
                            </RequireSpecificCompany>
                        }
                    />

                    <Route
                        path=":id"
                        element={<MotorcycleFormPage />}
                    />
                </Route>

                {/* Discounts */}
                <Route
                    path="discounts/list"
                    element={<DiscountsList />}
                />

                <Route
                    path="discounts/new"
                    element={
                        <RequireSpecificCompany action="create a discount">
                            <DiscountFormPage />
                        </RequireSpecificCompany>
                    }
                />

                <Route
                    path="discounts/edit/:id"
                    element={<DiscountFormPage />}
                />

                {/* Bookings */}
                <Route
                    path="bookings/list"
                    element={<BookingsList />}
                />

                <Route
                    path="bookings/new"
                    element={
                        <PrivateRoute requiredRole="ADMIN">
                            <BookingForm />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="bookings/edit/:id"
                    element={
                        <PrivateRoute requiredRole="ADMIN">
                            <BookingForm />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="bookings/:id/supplier-decision"
                    element={<SupplierDecisionRoute />}
                />

                {/* Requests */}
                <Route
                    path="requests/list"
                    element={<RequestsList />}
                />

                <Route
                    path="requests/edit/:id"
                    element={<RequestForm />}
                />

                {/* Reviews */}
                <Route
                    path="reviews/list"
                    element={<ReviewsList />}
                />

                <Route
                    path="reviews/edit/:id"
                    element={<ReviewForm />}
                />

                {/* Accounting */}
                <Route
                    path="accountings"
                    element={<AccountingsList />}
                />

                {/* Unverified companies */}
                <Route
                    path="unverified-companies/list"
                    element={
                        <PrivateRoute requiredRole="ADMIN">
                            <UnverifiedCompaniesList />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="unverified-companies/edit/:id"
                    element={
                        <PrivateRoute requiredRole="ADMIN">
                            <UnverifiedCompanyForm />
                        </PrivateRoute>
                    }
                />

                {/* Global motorcycle models */}
                <Route
                    path="models/list"
                    element={
                        <PrivateRoute requiredRole="ADMIN">
                            <Models />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="models/new"
                    element={
                        <PrivateRoute requiredRole="ADMIN">
                            <ModelForm />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="models/edit/:id"
                    element={
                        <PrivateRoute requiredRole="ADMIN">
                            <ModelForm />
                        </PrivateRoute>
                    }
                />

                {/* Codes */}
                <Route path="codes">
                    <Route path="promo">
                        <Route
                            index
                            element={<PromoCodesPage />}
                        />

                        <Route
                            path="new"
                            element={
                                <RequireSpecificCompany action="create a promotion code">
                                    <PromoCodeFormPage />
                                </RequireSpecificCompany>
                            }
                        />

                        <Route
                            path=":id"
                            element={<PromoCodeFormPage />}
                        />
                    </Route>

                    <Route path="credits">
                        <Route
                            index
                            element={<CreditCodesPage />}
                        />

                        <Route
                            path="new"
                            element={
                                <RequireSpecificCompany action="create a credit code">
                                    <CreditCodeFormPage />
                                </RequireSpecificCompany>
                            }
                        />

                        <Route
                            path=":id"
                            element={<CreditCodeFormPage />}
                        />
                    </Route>
                </Route>

                {/* Reports */}
                <Route
                    path="reports/sales"
                    element={<SalesReport />}
                />

                <Route
                    path="reports/insurance"
                    element={<InsuranceReport />}
                />

                <Route
                    path="reports/license"
                    element={<LicenseReport />}
                />

                {/* Support */}
                <Route
                    path="support/contact"
                    element={<ContactUs />}
                />
            </Route>

            {/* Not found */}
            <Route
                path="*"
                element={<NotFound />}
            />
        </Routes>
    );
}

export default AppRoutes;